export const apiUrl = '#{Kjarni.EmployeeWeb.apiUrl}'; // https://qdata.kjarni.applicon.is:port
export const supportEmail = '#{Kjarni.EmployeeWeb.supportEmail}'; // applicon@applicon.is
export const customer = '#{Kjarni.EmployeeWeb.customer}'; // dev
/* eslint global-require: 0 */
export const logo = '#{Kjarni.EmployeeWeb.logo}'; // logo.png
export const theme = '#{Kjarni.EmployeeWeb.theme}'; // {}
export const tags = [customer];
export const applicationInsightsInstrumentationKey = '#{Kjarni.Monitoring.InstrumentationKey}';
export const siteName = '#{Kjarni.Tenant.SiteName}';
export const useSSO = '#{Kjarni.EmployeeWeb.useSSO}'; // true | false
export const hiddenFeatures = '#{Kjarni.EmployeeWeb.hiddenFeatures}'; // {} | {"appraisals":"true"}
export const reverseListItemLabels = '#{Kjarni.EmployeeWeb.ReverseListItemLabels}';
export const hideXapLogin = '#{Kjarni.EmployeeWeb.HideXAPLogin}';
export const useMobileLogin = '#{Kjarni.EmployeeWeb.useMobileLogin}'; // true | false

export const msalTenantID = '#{Kjarni.Authentication.MSAL.TenantID}';
export const msalApplicationID = '#{Kjarni.Authentication.MSAL.ApplicationID}';
export const msalScope = '#{Kjarni.Authentication.MSAL.ApiScope}';

export const recaptchaKey = '#{Kjarni.EmployeeWeb.RecaptchaKey}';



// WEBPACK FOOTER //
// ./src/config/octopus/index.js